var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "gmail",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 666.67166 533.39521",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M733.33331,247.66665V633.33331A33.33336,33.33336,0,0,1,700,666.66664H566.66665a33.33336,33.33336,0,0,1-33.33334-33.33333V362A33.33344,33.33344,0,0,1,545,336.66663L678.33332,222.3333a33.28121,33.28121,0,0,1,55,25.33335ZM121.66667,222.33333a33.28122,33.28122,0,0,0-55,25.33332V633.33331A33.33335,33.33335,0,0,0,100,666.66664H233.33332a33.33335,33.33335,0,0,0,33.33334-33.33333V362A33.33337,33.33337,0,0,0,255,336.66663Z",
    transform: "translate(-66.66642 -133.27143)",
    fill: "#d5d5d5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M666.66664,144a112.66664,112.66664,0,0,0-122,17L400,285.33334,255,161A114,114,0,0,0,66.66666,247.66665,33.33335,33.33335,0,0,0,78.33333,273l300,257a33.33337,33.33337,0,0,0,43.33334,0l300-257a33.33338,33.33338,0,0,0,11.66662-25.33333A112.33328,112.33328,0,0,0,666.66664,144Z",
    transform: "translate(-66.66642 -133.27143)",
    fill: "#d99938"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.848636aa.svg";
export { ForwardRef as ReactComponent };